import { assertNever } from "@impero-com/common/utils/obj";

import { ControlRecurrenceRule } from "api/generated/model";

export function normalizeRecurrenceRule(rule: ControlRecurrenceRule) {
    switch (rule.type) {
        case "Date":
        case "Weekly":
            return rule;
        case "Monthly":
        case "EveryTwoMonths":
            return { ...rule, calendarId: rule.calendarId ?? null };
        case "Quarterly":
        case "HalfYearly":
        case "Yearly":
            return {
                ...rule,
                calendarId: rule.calendarId ?? null,
                financialYearId: rule.financialYearId ?? null,
            };
        default:
            return assertNever(rule);
    }
}
